import React, { useState } from 'react';
import './AgregarTarjeta.css';
import { ReactComponent as SubirArchivo } from '../assets/icon/subirarchivo.svg';
import { ReactComponent as Volver } from '../assets/icon/volver.svg';
import { useNavigate } from "react-router-dom";
import CalendarInicioTarjetas from '../Tarjetas/CalendarInicioTarjetas';
import CalendarFinTarjetas from '../Tarjetas/CalendarFinTarjetas';

function AgregarTarjeta() {
    const navigate = useNavigate();

    const [fileData, setFileData] = useState(null);
    const [fileName, setFileName] = useState("");

    const [nombre, setNombre] = useState("");
    const [tarjeta, setTarjeta] = useState("");

    // ---------- PARSE CSV ----------
    const allowedTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
        "application/vnd.ms-excel", // CSV (algunos navegadores lo detectan así)
        "text/csv", // CSV
    ];

    const handleFile = (file) => {
        if (!file) return;

        if (!allowedTypes.includes(file.type)) {
            alert("Solo se permiten archivos XLSX y CSV.");
            return;
        }

        setFileData(file);
        setFileName(file.name);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        handleFile(e.dataTransfer.files[0]);
    };

    const removeFile = () => {
        setFileData(null);
        setFileName("");
    };
    return (
        <div className='bodyAgregarTarjetas'>

            {/* TÍTULO */}
            <div className='tituloAgregarTarjetas'><p>-Tarjeta</p></div>
            <div className='cuerpoBotonVolverTarjetas'>
                <button
                    className='botonesAgregarTarjetas'
                    onClick={() => navigate("/dashboard/Tarjetas")}
                >
                    <div className="svgBotones"><Volver className="logo-svgBotones" /></div>
                    Volver
                </button>
            </div>

            <div className='cuerpoAgregarTarjetas'>

                {/* SUBIR ARCHIVO */}
                <div className="logoUpload">
                    <p className="label">Documento</p>

                    <div
                        className="uploadBox"
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={handleDrop}
                    >

                        {fileData ? (
                            <>
                                <p><strong>Archivo seleccionado:</strong> {fileName}</p>

                                {/* BOTONES */}
                                <div className="actions">

                                    <label className="actionButton cambiar">
                                        Cambiar
                                        <input
                                            type="file"
                                            accept=".xlsx,.csv"
                                            onChange={(e) => handleFile(e.target.files[0])}
                                            hidden
                                        />
                                    </label>

                                    <button
                                        className="actionButton eliminar"
                                        onClick={removeFile}
                                    >
                                        Eliminar
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="iconSubirArchivo">
                                    <div className="svgSubirArchivo">
                                        <SubirArchivo className="logosvgSubirArchivo" />
                                    </div>
                                </div>

                                <p>Seleccione o arrastre aquí el archivo o</p>

                                <label className="link">
                                    haga click para seleccionar
                                    <input
                                        type="file"
                                        accept=".xlsx,.csv"
                                        onChange={(e) => handleFile(e.target.files[0])}
                                        hidden
                                    />
                                </label>

                                <p>(Solo se permiten archivos XLSX y CSV)</p>
                            </>
                        )}
                    </div>
                </div>


                {/* INPUTS */}
                <div className='inputsTarjetas'>

                    {/* Numero de tarjeta */}
                    <div className="input-groupAgregarTarjetas">
                        <div className='text-inputAgregarTarjetas'>
                            <label>Numero de tarjeta</label>
                        </div>
                        <input
                            className="inputAgregarTarjetas"
                            type="Text"
                            maxLength={10}
                            value={nombre}
                            onChange={(e) => setNombre(e.target.value)}
                            placeholder="6B Invent Germany"
                        />
                        <div className="contador">{nombre.length}/10</div>
                    </div>

                    {/* Calendarios */}
                    <div className='calendario'>
                        <CalendarInicioTarjetas />
                        <div className="contadorFantasma">0/30</div>
                    </div>
                    <div className='calendario'>
                        <CalendarFinTarjetas />
                        <div className="contadorFantasma">0/30</div>
                    </div>

                    {/* Tipo tarjeta */}
                    <div className="input-groupAgregarTarjetas">
                        <div className='text-inputAgregarTarjetas'>
                            <label>Tipo de tarjeta</label>
                        </div>
                        <input
                            className="inputAgregarTarjetas"
                            type="Text"
                            maxLength={15}
                            value={tarjeta}
                            onChange={(e) => setTarjeta(e.target.value)}
                            placeholder="6B Invent Germany"
                        />
                        <div className="contador">{tarjeta.length}/15</div>
                    </div>

                    {/* Botones */}
                    <div className='botonesAgregarTarjetas2'>
                        <button type="button" className="btn-acceptGuardarTarjetas">Guardar</button>
                        <button type="button" className="btn-acceptConfirmarTarjetas">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AgregarTarjeta;
